import { autorun, observable, action, computed } from 'mobx'
import client from '../../../helpers/client'
import { asNormalizedMaps, asNormalizedArrays } from '../../../helpers/json-normalizer'

class Store {
  @observable ready = false
  @observable loading = true
  @observable franchise
  @observable backdropCategories = []
  @observable photoboothBackgrounds = []

  constructor({ widgetStore }) {
    this.widgetStore = widgetStore
    this.host = widgetStore.host
  }

  @computed get showCategoryHeaders() {
    return this.backdropCategories.length > 1
  }

  async setup() {
    this.loading = true
    await this.loadFranchise()
    await this.loadBackdrops()
    this.ready = true
    this.loading = false
  }

  loadFranchise() {
    return client.get(`${this.host}/api/v1/franchise`)
      .then(response => {
        const data = asNormalizedArrays(response.data)
        this.franchise = Object.values(data.franchise)[0]
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  loadBackdrops() {
    return client.get(`${this.host}/api/v1/photobooth_backgrounds?include=backdrop_category`)
      .then(response => {
        const data = asNormalizedMaps(response.data)
        this.backdropCategories = Array.from(data.backdropCategory.values())
          .sort((a, b) => a.attributes.position - b.attributes.position)
        this.photoboothBackgrounds = data.photoboothBackground
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  backdropsForCategory(backdropCategory) {
    const backdropIds = backdropCategory.relationships.photoboothBackgrounds.data.map(backdrop => backdrop.id)
    return backdropIds
      .map(id => this.photoboothBackgrounds.get(id))
      .filter(backdrop => backdrop)
      .sort((a, b) => a.attributes.position - b.attributes.position)
  }
}

export default Store
